import React, { useState } from 'react'
import { connect } from 'react-redux'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { FileUploadCell } from 'components'
import { getAttachmentGroups } from 'ducks/vendorMaintenance'
import { AttachmentContainer, AttachmentDisplayContainer } from './styled'
import { certificateFileGroup } from './data'
// import r from 'reactotron-react-js'

const CertificateAttachmentForm = (props) => {
  const { valueForm } = props
  const [showAttachment, setShowAttachment] = useState(true)

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Certificate'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowAttachment(!showAttachment) }>
            {showAttachment ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showAttachment}>
        <CardContent>
          <AttachmentContainer>
            {
              certificateFileGroup.map(d => 
                <AttachmentDisplayContainer>
                  <div className='title'>{d.name}</div>
                  {
                    (valueForm[`attachment${d.code.replace('VMA', '')}`] || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm[`attachment${d.code.replace('VMA', '')}`] || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer>
              )
            }
          </AttachmentContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    attachmentGroups: state.vendorMaintenance.attachmentGroups
  })
}
  

const mapDispatchToProps = {
  getAttachmentGroups
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificateAttachmentForm)